'use strict';

(function(global) {

  /**
   * Фабрика поисков.
   *
   * @class WebAccess.factories.searches.SearchFactory
   * @extends BaseObject
   */
  var SearchFactory = BaseObject.extend({

    /**
     * Конструктор.
     *
     * @method WebAccess.factories.searches.SearchFactory#init
     * @ignore
     */
    init: function () {
      this._super();
    },

    /**
     * Показывает результаты поиска в новом окне.
     *
     * @method WebAccess.factories.searches.SearchFactory#showResults
     * @param {string} uid Идентификатор поиска.
     */
    showResults: function (uid) {
      (new global.URL(`${window.location.origin}/Explorer.aspx`))
        .setParam('uid', uid)
        .setParam('mode', 'search')
        .open();
    }
  });

  window.WebAccess.factories.searches = new SearchFactory();

})(window.WebAccess);